(function () {
  const scriptUrl = document.currentScript ? document.currentScript.src : "";
  const assetBase = scriptUrl ? scriptUrl.slice(0, scriptUrl.lastIndexOf("/")) : "/cdn/shop/t/35/assets";
  const kidsCafeRoute = {
    key: "kids-cafe",
    canonicalPath: "/kids-cafe",
    title: "Kids Cafe | Zenbodi",
    description: "Kids Cafe by Zenbodi, a caffeine-free functional drink landing page for families.",
    bodyClass: "zen-theme--kids-cafe",
    css: `${assetBase}/kidscafe-theme-core.css`,
    js: `${assetBase}/kidscafe-theme-core.js`,
    sections: [
      "kidscafe-header",
      "kidscafe-index-assets",
      "kidscafe-index-03-hero-split-layout-ba",
      "kidscafe-index-04-scrolling-benefits-b",
      "kidscafe-index-05-founder-section-step",
      "kidscafe-index-06-press-bar-step",
      "kidscafe-index-07-shop-block-the-e-com",
      "kidscafe-index-08-trust-line-row-step",
      "kidscafe-index-09-science-backed-benef",
      "kidscafe-index-10-ingredient-grid-step",
      "kidscafe-index-11-how-to-make-it",
      "kidscafe-index-12-nutrition-gap-rebuil",
      "kidscafe-index-13-what-parents-tell-th",
      "kidscafe-index-14-super-flavors",
      "kidscafe-index-15-reviews-with-tabs-gr",
      "kidscafe-index-16-ugc-video-wall-step",
      "kidscafe-index-17-faq",
      "kidscafe-index-19-script",
      "kidscafe-index-20-sticky-add-to-cart-b",
      "kidscafe-index-21-pediapanel-modal-ove",
      "kidscafe-index-22-script",
      "kidscafe-cart-drawer",
      "kidscafe-footer"
    ]
  };
  const zenbeanRoute = {
    key: "zenbean",
    canonicalPath: "/zenbean",
    title: "ZenBean | Zenbodi",
    description: "ZenBean by Zenbodi, nootropic coffee for clean focus and sustained energy.",
    bodyClass: "zen-theme--zenbean",
    css: `${assetBase}/zenbean-theme-core.css`,
    js: `${assetBase}/zenbean-theme-core.js`,
    sections: [
      "zenbean-header",
      "zenbean-index-assets",
      "zenbean-index-04-hero",
      "zenbean-shop-handoff-assets",
      "zenbean-shop-product",
      "zenbean-shop-reviews-carousel",
      "zenbean-shop-comparison",
      "zenbean-shop-ugc",
      "zenbean-shop-ingredients",
      "zenbean-shop-reviews",
      "zenbean-shop-sticky",
      "zenbean-shop-handoff-script",
      "zenbean-cart-drawer",
      "zenbean-footer"
    ]
  };
  // /pages/kids-cafe is deliberately NOT mapped here. It is a real, server-rendered
  // template (page.kids-cafe.json -> kidscafe-v2-content) and the second URL in the
  // Meta A/B test. Hydrating it would rewrite its canonical to /kids-cafe and replace
  // its content with the old page, making the two test URLs indistinguishable.
  const routeConfigs = {
    "/kids-cafe": kidsCafeRoute,
    "/zenbean": zenbeanRoute,
    "/pages/zenbean": zenbeanRoute
  };

  const path = window.location.pathname.replace(/\/$/, "") || "/";
  const config = routeConfigs[path];
  if (!config) return;
  if (document.querySelector("[data-zen-server-route]")) return;

  const style = document.createElement("style");
  style.id = "zen-route-hydrator-style";
  style.textContent = `
    html.zen-client-route--kids-cafe {
      --zen-primary: #ef5555;
      --zen-background: #fdf6ec;
      --zen-text: #0a3a5c;
      --zen-header-background: #fdf6ec;
      --zen-header-text: #0a3a5c;
      --zen-footer-background: #1a1f2e;
      --zen-footer-text: #ffffff;
      --zen-footer-muted: #aaaaaa;
      --zen-display-font: Luckiest Guy, cursive;
      --zen-body-font: Nunito, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;
    }

    html.zen-client-route--zenbean {
      --zen-primary: #c8102e;
      --zen-background: #f5f1ea;
      --zen-text: #1a0f0a;
      --zen-header-background: #f5f1ea;
      --zen-header-text: #1a0f0a;
      --zen-footer-background: #1a0f0a;
      --zen-footer-text: #f5f1ea;
      --zen-footer-muted: #b8afa5;
      --zen-display-font: Space Grotesk, Georgia, serif;
      --zen-body-font: Inter Tight, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;
    }

    html.zen-client-route .shopify-section-group-header-group,
    html.zen-client-route .shopify-section-group-footer-group,
    html.zen-client-route .zen-recovery {
      display: none;
    }

    html.zen-client-route body {
      background: var(--zen-background);
    }

    .zen-client-route__loading {
      min-height: 100vh;
      background: var(--zen-background);
    }
  `;
  document.head.appendChild(style);

  document.documentElement.classList.add("zen-client-route", `zen-client-route--${config.key}`);
  document.documentElement.dataset.zenClientRoute = config.key;
  window.ZenClientRoute = config.key;

  document.title = config.title;
  const canonicalUrl = `${window.location.origin}${config.canonicalPath}`;
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = canonicalUrl;
  let description = document.querySelector('meta[name="description"]');
  if (!description) {
    description = document.createElement("meta");
    description.name = "description";
    document.head.appendChild(description);
  }
  description.content = config.description;

  const stylesheet = document.createElement("link");
  stylesheet.rel = "stylesheet";
  stylesheet.href = config.css;
  document.head.appendChild(stylesheet);

  const runScripts = (container) => {
    container.querySelectorAll("script").forEach((oldScript) => {
      const script = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attribute) => script.setAttribute(attribute.name, attribute.value));
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  };

  const loadRouteScript = () => {
    const script = document.createElement("script");
    script.defer = true;
    script.src = config.js;
    document.body.appendChild(script);
  };

  const fetchRouteSections = async (sectionIds) => {
    const chunkSize = 5;
    const chunks = [];
    for (let index = 0; index < sectionIds.length; index += chunkSize) {
      chunks.push(sectionIds.slice(index, index + chunkSize));
    }

    const renderedChunks = await Promise.all(chunks.map(async (chunk) => {
      const params = new URLSearchParams({ sections: chunk.join(",") });
      const response = await fetch(`/?${params.toString()}`, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      if (!response.ok) throw new Error(`Section render failed: ${response.status}`);
      return response.json();
    }));

    return Object.assign({}, ...renderedChunks);
  };

  const hydrateRoute = async () => {
    const main = document.getElementById("main-content");
    if (!main) return;

    document.body.classList.remove("zen-theme--zenbodi-hub");
    document.body.classList.add(config.bodyClass);
    main.classList.add("zen-client-route__loading");

    try {
      const sections = await fetchRouteSections(config.sections);
      const routeContainer = document.createElement("div");
      routeContainer.id = `zen-client-route-${config.key}`;
      routeContainer.dataset.zenClientRoute = config.key;
      routeContainer.innerHTML = config.sections.map((sectionId) => sections[sectionId] || "").join("");
      main.replaceChildren(routeContainer);
      main.classList.remove("zen-client-route__loading");
      runScripts(routeContainer);
      loadRouteScript();
    } catch (error) {
      console.error("Zenbodi route hydration failed", error);
      document.documentElement.classList.remove("zen-client-route", `zen-client-route--${config.key}`);
      main.classList.remove("zen-client-route__loading");
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateRoute, { once: true });
  } else {
    hydrateRoute();
  }
})();
